import { Table, TableBody, TableHead, TableRow } from '@mui/material'
import HFCard from '../../../../components/HFCard'
import { StyledTableCell, StyledTableRow } from '../../../../components/Table.styled'
import { QuaterlyReport } from '../types'
import { downloadReport } from '../service'
import { downloadFile } from '../../../../helpers/downloadFile'
import { useState } from 'react'
import { TableButton } from '../../../../components/Buttons.styled'
import { Download as DownloadIcon } from '@mui/icons-material'
import { addError } from '../../../../redux/alerts'
import { useAppDispatch } from '../../../../redux/store'

interface QuarterlyReportsTableProps {
  customerNumber: string
  quarterlyReports: QuaterlyReport[]
}

const QuarterlyReportsTable = ({ customerNumber, quarterlyReports }: QuarterlyReportsTableProps) => {
  const [downloadingReport, setDownloadingReport] = useState<string | null>(null)
  const dispatch = useAppDispatch()

  const handleDownload = async (report: QuaterlyReport) => {
    setDownloadingReport(report.fromDate)
    try {
      const options = {
        fromDate: report.fromDate,
        toDate: report.toDate
      }
      const blob = await downloadReport(customerNumber, options)
      const url = URL.createObjectURL(blob)
      const fileName = 'quarterly_report.pdf'
      await downloadFile({ url, fileName, isBlobURL: true })
    } catch (error) {
      console.error(error)
      dispatch(addError('There was a problem downloading this report'))
    }
    setDownloadingReport(null)
  }

  const reportDate = (report: QuaterlyReport) => {
    const quarters = [
      '',
      'January - March',
      'April - June',
      'July - September',
      'October - December'
    ]

    const quarter = quarters[report.quarter] || ''
    const status = !report.testCount ? 'There is no Quarterly report for ' : ''

    return `${status}${quarter} ${report.year}`.trim()
  }

  return (
    <HFCard headerText='Biological Monitoring Quarterly Reports'>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <StyledTableCell>Download</StyledTableCell>
            <StyledTableCell>Report Date</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {quarterlyReports?.map(report => (
            <StyledTableRow key={report.fromDate}>
              <StyledTableCell>
                {report.testCount && (
                  <TableButton
                    startIcon={<DownloadIcon/>}
                    variant='contained'
                    size='small'
                    disabled={report.fromDate === downloadingReport}
                    onClick={() => handleDownload(report)}
                  >
                    {report.fromDate !== downloadingReport ? 'Download' : 'Downloading...'}
                  </TableButton>
                )}
              </StyledTableCell>
              <StyledTableCell>{reportDate(report)}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </HFCard>
  )
}

export default QuarterlyReportsTable